import { useAtomValue, useSetAtom } from "jotai";
import { viewAtom } from "datasheets/model/atoms/WorkbookFocusAtoms";
import { Backdrop, CircularProgress } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import {
  loadWorkbookAtom,
  newWorkbookAtom,
} from "datasheets/model/atoms/WorkbookActionAtoms";
import { useMatch } from "react-router-dom";
import { ViewFactory, ViewProps } from "datasheets/model/ViewFactory";
import ViewRegistry from "../ViewRegistry";

export default function ViewContainer(props: ViewProps) {
  const view = useAtomValue(viewAtom);
  const loadWorkbook = useSetAtom(loadWorkbookAtom);
  const newWorkbook = useSetAtom(newWorkbookAtom);
  const params = useMatch("/workbook/:workbook_id");
  const workbook_id = params?.params["workbook_id"];
  useEffect(() => {
    if (workbook_id) {
      loadWorkbook(workbook_id);
    } else if (!props.testMode) {
      newWorkbook();
    }
  }, [workbook_id, loadWorkbook, newWorkbook]);
  const viewComponent = !!view ? (
    ViewFactory.component(view.config.type, props)
  ) : (
    <LoadingScreen />
  );
  return <Fragment key={view?.id ?? "Dummy"}>{viewComponent}</Fragment>;
}

function LoadingScreen() {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
      onClick={handleClose}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

// Register views
ViewRegistry.registerAll();
